@if (isBrowser) {
<div class="container py-4 d-flex justify-content-center">
    @if (invoiceData(); as data) {
        <!-- Print Button (hidden on print) -->
        <div class="w-100 invoice-container">
            <div class="d-flex justify-content-end mb-3 d-print-none">
                <button class="btn btn-outline-primary btn-sm" (click)="printInvoice()">
                    <i class="bi bi-printer me-1"></i> Print Invoice
                </button>
            </div>

            <!-- Invoice Box -->
            <div class="border border-dark rounded p-4 bg-white">

                <!-- Section 1: Header -->
                <div class="row mb-3 pb-3 border-bottom align-items-center">
                    <div class="col-md-4 text-center text-md-start mb-3 mb-md-0">
                        <img [src]="settings?.logo || '/assets/imgs/us_apostille_logo.png'" alt="Logo" class="img-fluid invoice-logo">
                    </div>
                    <div class="col-md-4 text-center mb-3 mb-md-0">
                        <h2 class="fw-bold mb-1 invoice-title">
                            {{ settings?.Name || 'Apostille' }}
                        </h2>
                        <h6 class="text-secondary text-uppercase fw-semibold mb-2 invoice-subtitle">
                            Invoice for Expedited Services
                        </h6>
                        <ul class="list-unstyled text-muted mb-0 mx-auto invoice-address-list">
                            <li class="mb-1"><i class="bi bi-geo-alt-fill me-1 opacity-75"></i>{{ settings?.Address || '1615 Bay Head Rd, Annapolis, MD 21409' }}</li>
                            <li><i class="bi bi-telephone-fill me-1 opacity-75"></i>{{ settings?.Phone || '(202) 869-0800' }}</li>
                        </ul>
                    </div>
                    <div class="col-md-4 d-flex justify-content-center justify-content-md-end">
                        <ngx-barcode6
                            [bc-format]="'CODE128'"
                            [bc-width]="1.2"
                            [bc-height]="40"
                            [bc-font-size]="11"
                            [bc-margin]="0"
                            [bc-value]="data.requestNumber"
                        >
                        </ngx-barcode6>
                    </div>
                </div>

                <!-- Section 2: User Info + Order Info (2 columns) -->
                <div class="row mb-4 pb-3 border-bottom">
                    <!-- Left Column: User/Form Data -->
                    <div class="col-md-6 mb-3 mb-md-0">
                        @if (data.address) {
                            @if (data.address.company) {
                                <p class="mb-1 fw-semibold">{{ data.address.company }}</p>
                            }
                            <p class="mb-1">{{ data.address.firstname }} {{ data.address.lastname }}</p>
                            <p class="mb-1">{{ data.address.address }}</p>
                            <p class="mb-1">
                                {{ data.address.city }}@if (data.address.state) {, {{ data.address.state }}}@if (data.address.country) {, {{ data.address.country }}} {{ data.address.zipcode }}
                            </p>
                            <p class="mb-1">{{ data.address.phone }}</p>
                            @if (data.address.cellphone) {
                                <p class="mb-1">Cell Phone: {{ data.address.cellphone }}</p>
                            }
                            <p class="mb-0">{{ data.address.email }}</p>
                        }
                    </div>

                    <!-- Right Column: Order Data -->
                    <div class="col-md-6">
                        <div>
                            <p class="mb-1"><span class="fw-semibold text-muted me-2">Invoice No:</span> {{ data.requestNumber }}</p>
                            <p class="mb-1"><span class="fw-semibold text-muted me-2">Date:</span> {{ data.expected_date }}</p>
                            <p class="mb-1"><span class="fw-semibold text-muted me-2">No. of Docs:</span> {{ getDocCount() }}</p>
                            <p class="mb-1"><span class="fw-semibold text-muted me-2">Payment Method:</span> Credit</p>
                            <p class="mb-1"><span class="fw-semibold text-muted me-2">Estimated Date:</span> {{ data.expected_date }}</p>
                            @if (data.address.reference) {
                                <p class="mb-0"><span class="fw-semibold text-muted me-2">Reference:</span> {{ data.address.reference }}</p>
                            }
                        </div>
                    </div>
                </div>

                <!-- Section 3: Order Details -->
                <div class="mb-4">
                    @for (item of data.cartItems; track $index) {

                        <h4>
                            {{item.document_name}}
                        </h4>
                        <table class="table table-bordered table-sm mb-3">
                            <thead class="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Document</th>
                                    <th class="text-center">Qty</th>
                                    <th class="text-end">Fee</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (ser of item.document_services; track $index) {
                                    <tr>
                                        <td>{{ $index + 1 }}</td>
                                        <td>{{ ser.Name }}</td>
                                        <td class="text-center">{{ ser.Count }}</td>
                                        <td class="text-end">${{ ser.Fee }}</td>
                                    </tr>
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="3">
                                        Total
                                    </td>
                                    <td>
                                        {{item.total_fee}}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    }

                    <!-- Totals Table -->
                    <table class="table table-sm mb-0 invoice-totals-table">
                        <tbody>
                            <tr>
                                <td class="fw-semibold">Subtotal</td>
                                <td class="text-end">${{ getSubtotal().toFixed(2) }}</td>
                            </tr>
                            @if (data.fedex_total_fees) {
                                <tr>
                                    <td class="fw-semibold">FedEx Fees</td>
                                    <td class="text-end">${{ data.fedex_total_fees.toFixed(2) }}</td>
                                </tr>
                            }
                            <tr>
                                <td class="fw-semibold">Handling Fee</td>
                                <td class="text-end">${{ data.handling_fees.toFixed(2) }}</td>
                            </tr>
                            <tr class="border-top">
                                <td class="fw-bold fs-6">Total</td>
                                <td class="text-end fw-bold fs-6">${{ getGrandTotal().toFixed(2) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <!-- FedEx Labels View -->
            @if (fedexLabels().length > 0) {
                <div class="mt-4 px-2 d-print-none">
                    <h3 class="mb-4 fw-bold text-primary">Shipping Labels</h3>
                    <div class="row g-4">
                        @for (label of fedexLabels(); track label) {
                            <div class="col-12">
                                <div class="card shadow-sm border-0">
                                    <div class="card-body p-0">
                                        <iframe [src]="label | safeUrl" width="100%" height="600px" style="border: none; border-radius: 4px;"></iframe>
                                    </div>
                                    <div class="card-footer bg-light border-top-0 text-center py-3">
                                        <a [href]="label" target="_blank" class="btn btn-primary px-4 fw-bold shadow-sm">
                                            <i class="bi bi-printer-fill me-2"></i>Print / Download Label
                                        </a>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            
        </div>
    } @else {
        <div class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3 text-muted">Loading invoice...</p>
        </div>
    }
</div>
}
